module.exports = __webpack_public_path__ + "img/QCM.93e64483.svg";